/*
 *  Copyright (c) 2024 - SimpliCity Digital Inc - All Rights Reserved
 */

import qs from 'qs'

/**
 *  parseParams
 *  @param {Object} params
 */
const parseParams = (params) => {
    return qs.parse(params);
}

export { parseParams }
